import { currentYear, yearsRange } from '../helpers/yearsRange';

const hasNextYear = document.getElementById('root').dataset.nextyear === 'true';
const lastYear = 1991;
const startYear = hasNextYear ? currentYear + 1 : currentYear;

/**
 * Config for catalogues dropdown filter
 */
export default {
    title: 'Year',
    name: 'year',
    defaultValue: currentYear,
    options: yearsRange(hasNextYear ? startYear : currentYear, false, startYear, lastYear)
};



// WEBPACK FOOTER //
// ./src/js/config/cataloguesFilter.js